<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>部门费用汇总表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="开始日期">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择年月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择年月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Jigouname" label="部门" min-width="23%"></el-table-column>
          <el-table-column prop="Gongzi" label="工资" min-width="7%"></el-table-column>
          <el-table-column prop="Shebao" label="社保" min-width="7%"></el-table-column>
          <el-table-column prop="Gongjijin" label="公积金" min-width="7%"></el-table-column>
          <el-table-column prop="Chailvfei" label="差旅费" min-width="7%"></el-table-column>
          <el-table-column prop="Zhaodaifei" label="招待费" min-width="7%"></el-table-column>
          <el-table-column prop="Bangongfei" label="办公费" min-width="7%"></el-table-column>
          <el-table-column prop="Zulingfie" label="租赁费" min-width="7%"></el-table-column>
          <el-table-column prop="Shuidianfei" label="水电费" min-width="7%"></el-table-column>
          <el-table-column prop="Yanfafei" label="研发费" min-width="7%"></el-table-column>
          <el-table-column prop="Yunshufei" label="运输费" min-width="7%"></el-table-column>
          <el-table-column prop="Qitafeiyong" label="其他费用" min-width="7%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
      </el-tab-pane>
      <!-- 清单列表 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyBumenfeiyonghuizongbiao',
  data () {
    return {
      activeName: 'first',
      // 查询
      keywords: {
        begintime: '',
        endtime: ''
      },
      dataList: []
    }
  },
  mounted () {
    this.apiBumenfeiyonghuizongbiaoList()
  },
  methods: {
    clicksearch () {
      this.apiBumenfeiyonghuizongbiaoList()
    },
    apiBumenfeiyonghuizongbiaoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_BumenfeiyonghuizongbiaoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
